import React, { useEffect, useRef } from "react";
import "./Bid.css";
import { Button, Form, Container, Row, Col } from "react-bootstrap";
import InputField from "@/components/common/InputField/InputField";
import LicenceInformationTable from "./LicenceInformationProfile";
import LicenceModal from "./LicenceModel";
import { useState } from "react";
import { checkSmsFeature, getUserProfile, saveUserDetails } from "@/api/bid";
import { stateListData } from "@/api/bid";
import { cityList } from "@/api/bid";
import validateForm from "./ValidateProfileInfo";
import LicenceInfoTable from "./LicenceInfoTable";
import CorporateInfoTable from "./CorporateInfoTable";
import { setUserProfileData } from "@/bidFeature/propertyDetailSlice";
import { isPhoneNoInUse } from "@/api/bid";
import { saveBuyerProfile } from "@/api/bid";
import { useDispatch } from "react-redux";
import ConfirmationModal from "./custom/ConfirmationModel";
import { isAgentHasActiveBidsAndOffer } from "@/api/bid";
import { allLicenceDetails } from "@/api/bid";
import { setAllLicenseInfo } from "@/bidFeature/propertyDetailSlice";
// import { Alert } from "bootstrap";
import Loader from "../common/loader/Loader";
import { getCitiesByState, getUserSmsOptInDetails } from "@/api/myProfile";
import { ShimmerCard, ShimmerText } from "react-shimmer-effects";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
// import { set } from "lodash";
// import Loader from "../common/loader/Loader";

const ProfileInfoForm = ({
  handleone,
  offerPage,
  setSubmittedAccordions,
  setaccordianOpen,
}) => {
  const trackingTimeoutRef = useRef(null);

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  // console.log("selector", selector);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    userId: "",
    phoneNumber: "",
    companyName: "",
    address1: "",
    address2: "",
    city: "",
    cityFromDropDown: false,
    state: "",
    zip: "",
    userRoles: [],
    smsOptInStatus: null,
  });
  const [formErrors, setFormErrors] = useState({});
  const [stateData, setStateData] = useState([]);
  const [cityData, setcityData] = useState([]);
  const [userRoles, setUserRoles] = useState([]); // for storing roles array
  const [userRole, setUserRole] = useState(""); // for storing single role

  const [licenceInfoTableData, setLicenceInfoTableData] = useState([]);
  const [corporateInfoTableData, setCorporateInfoTableData] = useState([]);
  const [validated, setValidated] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingRoleChange, setPendingRoleChange] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showSmsOptInOptionFlag, setShowSmsOptInOptionFlag] = useState(false);
  const [receiveOtp, setReceiveOtp] = useState("");
  const [smsFeatureEnabled, setSmsFeatureEnabled] = useState(false);
  const [smsForState, setSmsForState] = useState("");
  const [licenseErrMsg, setLicenseErrMsg] = useState("");
  const [cityForLiecense, setCitiesForLiecnse] = useState([]);
  const [licenseCityDropDowm, setLicenseCityDropDown] = useState("");
  const [filledFieldsCount, setFilledFieldsCount] = useState(1);
  const [previouslyFilledFields, setPreviouslyFilledFields] = useState("");

  const dispatch = useDispatch();

  const handleShow = () => {
    setShow(true);
    trackButtonClick({
      eventName: "bid_add_license_click",
      eventCategory: "Profile-Forms Bid/Offer wizard",
      eventLabel: "Agent | addLicense",
      eventSource: "on add license button click",
      eventParams: { license_type: "agent", license_scope: "individual" },
    });
  };

  const handleClose = () => setShow(false);

  const handleShow2 = () => {
    setShow2(true);
    trackButtonClick({
      eventName: "bid_add_license_click",
      eventCategory: "Profile-Forms Bid/Offer wizard",
      eventLabel: "Agent | addCorporateLicense",
      eventSource: "on add license button click",
      eventParams: { license_type: "agent", license_scope: "corporate" },
    });
  };
  const handleClose2 = () => setShow2(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission
    handleClose();
  };

  const handleSubmit2 = (event) => {
    event.preventDefault();
    // Handle form submission
    handleClose2();
  };

  useEffect(() => {
    return () => {
      if (trackingTimeoutRef.current) {
        clearTimeout(trackingTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    getUserProfile().then(async (response) => {
      const {
        firstName,
        lastName,
        emailId,
        phoneNumber,
        userRoles: roles,
        userId,
        address: { address1, address2, city, state, zip },
        showSmsOptInOptionFlag,
      } = response?.data?.userDetails;

      if (
        !(
          response?.data === null ||
          response?.data?.userDetails?.address?.address1 === null ||
          response?.data?.userDetails?.address?.address1?.length === 0 ||
          response?.data?.userDetails?.address?.city === null ||
          response?.data?.userDetails?.address?.city?.length === 0
        )
      ) {
        handleone();
      }
      // console.log("response userdetails", response?.data?.userDetails?.address?.address1);
      // First, load the states
      const stateResponse = await stateListData();
      setStateData(stateResponse?.data || []);
      setShowSmsOptInOptionFlag(showSmsOptInOptionFlag);
      setUserRoles(roles || []);
      if (roles?.includes("AGENT")) {
        setUserRole("AGENT");
      } else if (roles?.includes("BUYR")) {
        setUserRole("BUYR");
      }
      // console.log("userroles", userRoles[1]);
      // setUserRole(userRoles[1] || "BUYR");
      // If there's a state, load the cities for that state
      if (state) {
        const cityResponse = await cityList(state);
        setcityData(cityResponse?.data?.data || []);
      }

      // Now set the form data after cities are loaded
      // setFormData({
      //   firstName,
      //   lastName,
      //   emailId,
      //   address1,
      //   address2,
      //   state,
      //   city, // Now this will work because cities are loaded
      //   zip,
      //   phoneNumber,
      // });
      setFormData({
        ...formData,
        firstName: firstName || "",
        lastName: lastName || "",
        emailId: emailId || "",
        phoneNumber: phoneNumber || "",
        role: userRoles[0] || "BUYR",
        address1: address1 || "",
        address2: address2 || "",
        city: city || "",
        cityFromDropDown: false,
        state: state,
        zip: zip,
        userId: userId || "",
      });
    });
  }, []);

  useEffect(() => {
    // Load cities when state changes
    if (formData.state) {
      cityList(formData.state).then((res) => {
        // console.log("Cities loaded:", res.data?.data);
        setcityData(res?.data?.data || []);
      });
    }
  }, [formData.state]);
  useEffect(() => {
    const fetch = async () => {
      if (licenseCityDropDowm) {
        const citiesData = await getCitiesByState(licenseCityDropDowm);
        const cityArray = citiesData.data || citiesData;
        setCitiesForLiecnse(Array.isArray(cityArray) ? cityArray : []);
      }
    };
    fetch();
  }, [licenseCityDropDowm]);

  const statusList = ["Pending", "Active", "Expired"];

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Validate the field dynamically
    const validationErrors = validateForm({ [name]: value }, [name]);

    // Update form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (name === "state" || name === "city") {
      trackButtonClick({
        eventName: "bid_account_info_update",
        eventCategory: "Profile-Forms Bid/Offer wizard",
        eventLabel: `Field Name : ${name} | Event Number : ${
          filledFieldsCount || 1
        } | Previously filled Field Names : ${
          previouslyFilledFields || ""
        } | user Type:${
          formData.role || formData.userRoles?.[0] || "BUYR"
        }| Action Type : new`,
      });
      setFilledFieldsCount((prev) => prev + 1);

      // Update previously filled fields
      setPreviouslyFilledFields((prev) => (prev ? `${prev}, ${name}` : name));
    }

    // Update errors dynamically
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: validationErrors[name] || "", // Add error message or clear if valid
    }));
  };

  const profileInfoDetails = [
    {
      label: "First Name",
      type: "text",
      placeholder: "First Name",
      required: true,
      editLink: false,
      formValueLabel: "firstName",
    },
    {
      label: "Last Name",
      type: "text",
      placeholder: "Last Name",
      required: true,
      editLink: false,
      formValueLabel: "lastName",
    },
    {
      label: "Email",
      type: "email",
      placeholder: "Email Id",
      required: true,
      editLink: true,
      formValueLabel: "emailId",
    },
    {
      label: "Address Line 1",
      type: "text",
      placeholder: "Enter your Address",
      required: true,
      editLink: false,
      formValueLabel: "address1",
    },
    {
      label: "Address Line 2",
      type: "text",
      placeholder: "Enter your Address",
      required: false,
      editLink: false,
      formValueLabel: "address2",
    },
    {
      label: "State",
      type: "dropdown",
      placeholder: "State",
      required: true,
      editLink: false,
      formValueLabel: "state",
    },
    {
      label: "City",
      type: "dropdown",
      placeholder: "City",
      required: true,
      editLink: false,
      formValueLabel: "city",
    },
    {
      label: "Zip code",
      type: "number",
      placeholder: "Zip Code",
      required: true,
      editLink: false,
      formValueLabel: "zip",
      maxLength: "5",
    },
    {
      label: "Mobile",
      type: "number",
      placeholder: "Phone Number",
      required: true,
      editLink: false,
      formValueLabel: "phoneNumber",
      maxLength: 10,
    },
  ];

  const addLicenseInfo = [
    {
      label: "Issued By",
      type: "text",
      placeholder: "Issued By",
      required: true,
      formValueLabel: "IssueBy",
    },
    {
      label: "License Number",
      type: "text",
      placeholder: "License Number",
      required: true,
      formValueLabel: "LicenseNumber",
    },
    {
      label: "Expiry Date",
      type: "date",
      required: true,
      formValueLabel: "ExpiryDate",
    },
    {
      label: "State",
      type: "select",
      required: true,
      formValueLabel: "state",
      options: stateData.map((item) => ({
        value: item,
        label: item,
      })),
    },
    {
      label: "Address Line 1",
      type: "text",
      placeholder: "Address Line 1",
      formValueLabel: "AddressLine1",
    },
    {
      label: "Address Line 2",
      type: "text",
      placeholder: "Address Line 2",
      formValueLabel: "AddressLine2",
    },
    {
      label: "Agent License State",
      type: "select",
      formValueLabel: "agentLicenseState",
      options: stateData.map((item) => ({
        value: item,
        label: item,
      })),
    },
    {
      label: "City",
      type: "text",
      placeholder: "City",
      formValueLabel: "city",
      options: cityForLiecense,
    },
    {
      label: "Zip Code",
      type: "text",
      placeholder: "Zip Code",
      formValueLabel: "zipcode",
    },
  ];

  const handleState = (e) => {
    const selectedState = e.target.value;
    // console.log("Selected State:", selectedState);
    // Update formData with selected state
    setFormData((prev) => ({
      ...prev,
      state: selectedState,
      city: "", // Reset city when state changes
    }));
    cityList(selectedState).then((res) => {
      // console.log(res.data.data);
      setcityData(res.data?.data || []);
    });
  };
  const handleCity = (e) => {
    const selectedCity = e.target.value;
    // console.log("Selected city:", selectedCity);

    setFormData((prev) => ({
      ...prev,
      city: selectedCity,
    }));
    // Clear the error for city if a value is selected
    if (selectedCity) {
      setFormErrors((prev) => ({
        ...prev,
        city: "",
      }));
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation

    const error = validateField(name, value);
    setFormErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleRoleChange = async (e) => {
    const newRole = e.target.value;
    setLicenseErrMsg("");
    const currentRole = formData.role || formData.userRoles?.[0] || "BUYR";

    // console.log('in',newRole,currentRole);

    try {
      if (currentRole === "agent" && newRole === "BUYR") {
        try {
          const response = await isAgentHasActiveBidsAndOffer();

          trackButtonClick({
            eventName: "bid_account_info_update",
            eventCategory: "Profile-Forms Bid/Offer wizard",
            eventLabel: `Field Name : userTypeRadioAgent | Event Number : ${
              filledFieldsCount || 1
            } | Previously filled Field Names : ${
              previouslyFilledFields || ""
            } | user Type:${newRole}| Action Type : new`,
          });
          setFilledFieldsCount((prev) => prev + 1);

          if (response.hasActiveBidsAndOffers) {
            setPendingRoleChange(newRole);
            setShowConfirmModal(true);
            // Reset select to current value until confirmed
            e.target.value = formData.role;
            return;
          }
          setPendingRoleChange(newRole);
          setShowConfirmModal(true);
        } catch (error) {
          console.error("Error checking active bids/offers:", error);
          return;
        }
      } else {
        setPendingRoleChange(newRole);
        setShowConfirmModal(true);
        // Reset select to current value until confirmed
        // For other role switches
        // e.target.value = formData.role;
      }

      // Update the role
    } catch (error) {
      console.error("Error during role change:", error);
      // Handle error appropriately
    }
  };

  const getConfirmationMessage = () => {
    const currentRole = formData.role || formData.userRoles?.[0] || "BUYR";

    if (currentRole === "agent" && pendingRoleChange === "BUYR") {
      return "Are you sure want to switch your role? All your licenses will be deleted. Please confirm.";
    }
    return "Are you sure want to switch the role?";
  };

  const handleConfirmRoleChange = async () => {
    try {
      const currentRole = formData.role || formData.userRoles?.[0] || "BUYR";

      trackButtonClick({
        eventName: "bid_account_info_update",
        eventCategory: "Profile-Forms Bid/Offer wizard",
        eventLabel: `Field Name : userTypeRadioAgent | Event Number : ${
          filledFieldsCount || 1
        } | Previously filled Field Names : ${
          previouslyFilledFields || ""
        } | user Type:${pendingRoleChange}| Action Type : new`,
      });
      setFilledFieldsCount((prev) => prev + 1);

      // Call allLicenceDetails only when switching from BUYR to agent
      if (currentRole === "BUYR" && pendingRoleChange === "agent") {
        const licenseResponse = await allLicenceDetails();
        // console.log("License details in profile info form:", licenseResponse);
        dispatch(setAllLicenseInfo(licenseResponse));
      }
      // Update the role
      setFormData((prev) => ({
        ...prev,
        role: pendingRoleChange,
      }));
      setUserRole(pendingRoleChange);
      setShowConfirmModal(false);
      setPendingRoleChange(null);
    } catch (error) {
      console.error("Error during role change:", error);
      // Handle error appropriately
      setShowConfirmModal(false);
    }
  };

  const handleCancelRoleChange = () => {
    setShowConfirmModal(false);
    setPendingRoleChange(null);
  };
  const validateField = (name, value) => {
    let error = "";

    // First check if field is empty and required
    if (!value && name !== "address2") {
      return "This field is required";
    }

    // If field has value, validate format
    if (value) {
      switch (name) {
        case "firstName":
        case "lastName":
          if (!/^[a-zA-Z0-9\-.'_]{1,30}$/.test(value)) {
            error = `Characters allowed: a-z A-Z 0-9 and - . ' _`;
          }
          break;

        case "emailId": // or "email"
          if (!value.includes("@")) {
            error = "Email must contain @ symbol";
          } else if (
            !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
          ) {
            error = "Please enter a valid email address";
          }
          break;

        case "address1":
          if (!/^[a-zA-Z0-9#(),'\s]*$/.test(value)) {
            error = "Please enter a valid address.";
          }
          break;
        case "address2":
          if (!/^[a-zA-Z0-9#(),'\s]*$/.test(value)) {
            error = "Please enter a valid street number.";
          }
          break;

        case "state":
          if (!value) {
            error = "Please select a state";
          }
          break;

        case "city":
          if (!value) {
            error = "Please select a city";
          }
          break;

        case "zip":
          if (!/^[0-9]{5}$/.test(value)) {
            error = "Please Enter valid zipcode";
          }
          break;

        case "phoneNumber":
          if (!/^[0-9]{10}$/.test(value)) {
            error = "Please Enter a valid Phone Number";
          }
          break;
      }
    }

    return error;
  };
  // const handleProfileFormSubmit = (e) => {
  //   e.preventDefault();
  //   const { isValid, errors } = validateForm(formData);
  //   if (!isValid) {
  //     console.log(errors);
  //     setFormErrors(errors);
  //     return;
  //   } else {
  //     setFormErrors({});
  //     console.log(formData);
  //     // handleone();
  //   }
  // };

  const onHandleBlur = (e) => {
    const { name, value } = e.target;
    // Clear any existing timeout
    if (trackingTimeoutRef.current) {
      clearTimeout(trackingTimeoutRef.current);
    }

    // Set a new timeout for tracking
    trackingTimeoutRef.current = setTimeout(() => {
      trackButtonClick({
        eventName: "bid_account_info_update",
        eventCategory: "Profile-Forms Bid/Offer wizard",
        eventLabel: `Field Name : ${name} | Event Number : ${
          filledFieldsCount || 1
        } | Previously filled Field Names : ${
          previouslyFilledFields || ""
        } | user Type:${
          formData.role || formData.userRoles?.[0] || "BUYR"
        }| Action Type : new`,
      });
      setFilledFieldsCount((prev) => prev + 1);

      // Update previously filled fields
      setPreviouslyFilledFields((prev) => (prev ? `${prev}, ${name}` : name));
    }, 1000);
  };

  const handleProfileFormSubmit = (e) => {
    e.preventDefault();
    setValidated(true);

    // Required fields array
    const requiredFields =
      offerPage && !smsFeatureEnabled && smsForState === "Y"
        ? [
            "firstName",
            "lastName",
            "emailId",
            "address1",
            "state",
            "city",
            "zip",
            "phoneNumber",
            "receive-otp",
          ]
        : [
            "firstName",
            "lastName",
            "emailId",
            "address1",
            "state",
            "city",
            "zip",
            "phoneNumber",
          ];

    let newErrors = {};
    let hasErrors = false;

    // Validate all required fields

    requiredFields.forEach((fieldName) => {
      const value =
        fieldName === "receive-otp" ? receiveOtp : formData[fieldName] || "";
      // console.log(`Validating ${fieldName}:`, value); // Debug log

      const error = validateField(fieldName, value);
      if (error) {
        newErrors[fieldName] = error;
        hasErrors = true;
      }
    });

    setFormErrors(newErrors);

    if (!hasErrors) {
      // console.log("Form is valid", formData);
      isPhoneNoInUse(formData.phoneNumber);

      // console.log("newrollll", newRole);
      const currentRole = formData.role || formData.userRoles?.[0] || "BUYR";
      const smsStatus = offerPage
        ? !smsFeatureEnabled && smsForState === "Y"
          ? receiveOtp
          : null
        : null;

      trackButtonClick({
        eventName: "bid_profile_verification_continue",
        eventCategory: "Bid/Offer wizard",
        eventSource: "profile accordion continue button",
      });

      if (currentRole === "BUYR") {
        setIsLoading(true); // Start loading

        const buyerpayload = {
          agentDetails: null,
          userDetails: {
            firstName: formData.firstName,
            lastName: formData.lastName,
            emailId: formData.emailId,
            userId: formData.userId,
            phoneNumber: formData.phoneNumber,
            companyName: "",
            smsOptInStatus: smsStatus,
            userRoles: [formData.role || "BUYR"],
            address: {
              address1: formData.address1,
              address2: formData.address2 || "",
              city: formData.city,
              cityFromDropDown: true,
              state: formData.state,
              zip: formData.zip,
            },
          },
        };
        // Call buyer profile API
        saveBuyerProfile(buyerpayload)
          .then((res) => {
            if (res.status === "SUCCESS") {
              trackApiCall({
                eventName: "bid_profile_update_success",
                eventCategory: "Profile UpdateBid/Offer wizard",
                eventSource: "on save success",
              });
              handleone(); // Navigate or perform next action
            } else {
              const errorMessage = res.errorMessage;
              trackApiCall({
                eventName: "bid_profile_update_failure",
                eventCategory: `Bid/Offer wizard - ${errorMessage}`,
                eventLabel: formData?.role,
                eventParams: { error_message: `${errorMessage}`, role: formData?.role },
              });

              if (
                errorMessage === "REGISTRATION_ZIP_FAILURE" ||
                errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
              ) {
                setFormErrors({
                  ...formErrors,
                  zip: "Provided zip code is not valid for the state",
                });
              } else if (errorMessage === "REGISTRATION_CITY_FAILURE") {
                setFormErrors({
                  ...formErrors,
                  city: "Provided city name is not valid for the state",
                });
              } else if (errorMessage.includes("Address")) {
                setFormErrors({
                  ...formErrors,
                  addressLine1: errorMessage,
                });
              }
            }
          })
          .catch((error) => {
            console.error("Error saving buyer profile:", error);
          })
          .finally(() => {
            setIsLoading(false); // Stop loading after API call completes
          });
      } else if (currentRole === "agent") {
        setIsLoading(true); // Start loading before API call

        const agentPayload = {
          firstName: formData.firstName,
          lastName: formData.lastName,
          emailId: formData.emailId,
          userId: formData.userId,
          phoneNumber: formData.phoneNumber,
          companyName: "",
          smsOptInStatus: smsStatus,
          userRoles: [formData.role.toUpperCase() || "BUYR"],
          // licenseNumber: formData.licenseNumber,
          address: {
            address1: formData.address1,
            address2: formData.address2 || "",
            city: formData.city,
            cityFromDropDown: false,
            state: formData.state,
            zip: formData.zip,
          },
        };
        // Call agent profile API
        saveUserDetails(agentPayload) // Assuming you have this function
          .then((res) => {
            if (res.data && res.data?.status === "SUCCESS") {
              trackApiCall({
                eventName: "bid_profile_update_success",
                eventCategory: "Profile UpdateBid/Offer wizard",
                eventSource: "on save success",
              });
              handleone();
            } else {
              const errorMessage = res.data.errorMessage;
              trackApiCall({
                eventName: "bid_profile_update_failure",
                eventCategory: `Bid/Offer wizard - ${errorMessage}`,
                eventLabel: formData?.role,
                eventParams: { error_message: `${errorMessage}`, role: formData?.role },
              });

              if (
                errorMessage === "REGISTRATION_ZIP_FAILURE" ||
                errorMessage === "VALIDATION_STATE_ZIP_FAILURE"
              ) {
                setFormErrors({
                  ...formErrors,
                  zip: "Provided zip code is not valid for the state",
                });
              } else if (errorMessage === "REGISTRATION_CITY_FAILURE") {
                setFormErrors({
                  ...formErrors,
                  city: "Provided city name is not valid for the state",
                });
              } else if (errorMessage.includes("Address")) {
                setFormErrors({
                  ...formErrors,
                  addressLine1: errorMessage,
                });
              } else if (errorMessage === "MISSING_LICENSE_ALERT") {
                setLicenseErrMsg("Please enter valid license details");
              }
            }
          })
          .catch((error) => {
            console.error("Error saving agent profile:", error);
          })
          .finally(() => {
            setIsLoading(false); // Stop loading after API call completes
          });
      }
    } else {
      // console.log("Form has errors", newErrors);
      // setFormErrors(newErrors);
    }
  };
  // console.log(showSmsOptInOptionFlag , smsFeatureEnabled,'smsms');

  const smsDetails = async () => {
    try {
      const details = await getUserSmsOptInDetails();
      const smsBasedOnState = await checkSmsFeature(formData?.state);

      setSmsFeatureEnabled(details?.data?.smsFeatureEnabled);
      setSmsForState(smsBasedOnState?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    smsDetails();
  }, [formData?.state]);

  {
    isLoading && (
      <div className="loader-container">
        <ShimmerCard />
      </div>
    );
  }

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="row">
              <Container className="profile-info-form">
                <form
                  noValidate
                  validated={validated}
                  className="profile-form"
                  // onSubmit={handleProfileFormSubmit}
                >
                  <div className="input-field-wrapper">
                    <InputField
                      label="I am a"
                      type="radio"
                      placeholder="Select a role"
                      width="50%"
                      required={true}
                      value={formData.role || formData.userRoles?.[0] || "BUYR"}
                      selected={
                        formData.role || formData.userRoles?.[0] || "BUYR"
                      }
                      onChange={handleRoleChange}
                      options={[
                        { value: "BUYR", label: "Buyer", key: 1 },
                        { value: "agent", label: "Agent", key: 2 },
                      ]}
                    />
                  </div>

                  {profileInfoDetails.map((item, index) => {
                    if (item.label === "State" || item.label === "City") {
                      return (
                        <>
                          <ConfirmationModal
                            isOpen={showConfirmModal}
                            onClose={handleCancelRoleChange}
                            onConfirm={handleConfirmRoleChange}
                            message={getConfirmationMessage()}
                            title="User Role"
                          />
                          <InputField
                            key={index}
                            label={item.label}
                            type={item.type}
                            name={item.formValueLabel}
                            value={formData[item.formValueLabel] || ""}
                            placeholder={item.placeholder}
                            width="50%"
                            maxLength={item?.maxLength ? item?.maxLength : ""}
                            required={item.required}
                            options={
                              item.label === "State"
                                ? Array.isArray(stateData)
                                  ? stateData.map((state, idx) => ({
                                      value: state,
                                      label: state,
                                      key: idx,
                                    }))
                                  : []
                                : Array.isArray(cityData)
                                ? cityData.map((city, idx) => ({
                                    value: city,
                                    label: city,
                                    key: idx,
                                  }))
                                : []
                            }
                            onChange={handleChange} // Use the dynamic handleChange function
                            disabled={item.label === "City" && !formData.state} // Disable city dropdown if state not selected
                            error={formErrors[item.formValueLabel]} // Pass the dynamic error state
                          />
                        </>
                      );
                    } else {
                      return (
                        <>
                          <InputField
                            key={index}
                            label={item.label}
                            formValueLabel={item.formValueLabel}
                            placeholder={item.placeholder}
                            type={item.type}
                            required={item.required}
                            disabled={
                              item.formValueLabel === "emailId" ? true : false
                            }
                            width="50%"
                            isEmailField={item.editLink}
                            name={item.formValueLabel}
                            value={formData[item.formValueLabel] || ""}
                            onChange={handleInputChange} // Updated to use handleInputChange function
                            handleBlur={onHandleBlur}
                            fromBidWizard={true}
                            error={formErrors[item.formValueLabel]}
                            maxLength={item.maxLength ? item.maxLength : ""}
                          />
                          {/* {formErrors[item.formValueLabel] && (
                            <p className="text-danger">
                              {formErrors[item.formValueLabel]}
                            </p>
                          )} */}
                        </>
                      );
                    }
                  })}
                  {offerPage && smsForState === "Y" && !smsFeatureEnabled && (
                    <>
                      <div className="d-flex">
                        <InputField
                          label={"Subscribe for text messages / alerts"}
                          type={"dropdown"}
                          name={"receive-otp"}
                          value={receiveOtp}
                          placeholder={"Select"}
                          width="50%"
                          required={true}
                          key={"index"}
                          onChange={(e) => {
                            setReceiveOtp(e.target.value);
                            setFormErrors({
                              ...formErrors,
                              ["receive-otp"]: "",
                            });

                            trackButtonClick({
                              eventName: "bid_account_info_update",
                              eventCategory: "Profile-Forms Bid/Offer wizard",
                              eventLabel: `Field Name : receive-otp | Field Value : ${
                                e.target.value
                              } | user Type:${
                                formData.role ||
                                formData.userRoles?.[0] ||
                                "BUYR"
                              }| Action Type : new`,
                            });
                          }}
                          error={formErrors["receive-otp"]}
                          options={[
                            { value: "Y", label: "Yes", key: 1 },
                            { value: "N", label: "No", key: 2 },
                          ]}
                        />
                        <span className="sms-opt-in-label px-2 pt-2">
                          Do you want to receive important text message
                          notifications related to your bids?
                        </span>
                      </div>
                      {/* {
                        receiveOtp==="Y"&&

                      <p className="sms-opt-in-label">

I agree to be contacted according to these <a href="/about/terms"  className="tnc-a" target="_blank">Terms & Conditions</a> . This consent includes receiving autodialed calls and texts from Altisource Online Auction, Inc. and its affiliates. I understand that this consent is not a condition to receiving any services.
                      </p>
} */}
                    </>
                  )}
                </form>
                {/* Add this to show any general form errors */}

                {userRole === "agent" && (
                  <>
                    <div className="license-table-container">
                      {licenseErrMsg !== "" && (
                        <div
                          style={{
                            color: "red",
                            fontSize: 13,
                            fontFamily: "robotomedium",
                            paddingBottom: 5,
                          }}
                        >
                          {licenseErrMsg}
                        </div>
                      )}
                      <LicenceInfoTable
                        heading={"License Information"}
                        handleShow={handleShow}
                        setShow={setShow}
                        show={show}
                        addLicenseInfo={addLicenseInfo}
                        handleSubmit={handleSubmit}
                        handleClose={handleClose}
                        formData={formData}
                        setLicenseErrMsg={setLicenseErrMsg}
                        setLicenseCityDropDown={setLicenseCityDropDown}
                      />
                    </div>
                    <CorporateInfoTable
                      heading={"Corporate License Information"}
                      handleShow={handleShow2}
                      setShow={setShow2}
                      show={show2}
                      addLicenseInfo={addLicenseInfo}
                      handleSubmit={handleSubmit2}
                      handleClose={handleClose2}
                      formData={formData}
                    />
                  </>
                )}
                {offerPage &&
                  smsForState === "Y" &&
                  receiveOtp === "Y" &&
                  !smsFeatureEnabled && (
                    <p className="sms-opt-in-label">
                      I agree to be contacted according to these{" "}
                      <a href="/about/terms" className="tnc-a" target="_blank">
                        Terms & Conditions
                      </a>{" "}
                      . This consent includes receiving autodialed calls and
                      texts from Altisource Online Auction, Inc. and its
                      affiliates. I understand that this consent is not a
                      condition to receiving any services.
                    </p>
                  )}
                <Button
                  onClick={handleProfileFormSubmit}
                  variant="primary"
                  // style={{ borderRadius: "20px" }}
                  className={"continueCTA-offer"}
                >
                  {isLoading ? "Continue..." : "Continue"}
                </Button>
                {isLoading && (
                  <div className="loader-container">
                    <ShimmerText line={2} gap={10} />
                  </div>
                )}
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileInfoForm;
